import * as Scrivito from "scrivito";
import textWidgetIcon from "assets/images/text_widget.svg";

Scrivito.provideEditingConfig("TextWidget", {
  title: "Text",
  thumbnail: textWidgetIcon,
  attributes: {
    title: {
      title: "Title",
    },
    body: {
      title: "Body",
    },
    links: {
      title: "Links",
    },
    complementaryText: {
      title: "Complementary text",
    },
  },
  properties: ["title", "body"],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["complementaryText", "links"],
    },
  ],
});
